import React from "react";
import "./ProjectsApp.css";
import reddishIcon from "./assets/reddish.png";
import nommiesIcon from "./assets/nommies.png";
import planitIcon from "./assets/planit.png";
import breastIcon from "./assets/breast.png";
import chicagoIcon from "./assets/chicago.png";
import bopitIcon from "./assets/bopit.png";

const ProjectsApp = () => {
  const projects = [
    {
      id: 1,
      name: "Reddish",
      description:
        "A from-scratch Redis-compatible server implementation inspired by the original Redis.",
      technologies: [
        "C++",
        "TCP Sockets",
        "RESP Protocol",
        "Multi-threading",
        "OOP",
      ],
      status: "Live",
      link: "https://github.com/kennythai2003/reddish",
      image: reddishIcon,
    },
    {
      id: 2,
      name: "Nommies",
      description:
        "Food discovery app to find and share your favorite restaurants and recipes.",
      technologies: ["React", "Express", "MongoDB", "Node.js", "OAuth"],
      status: "Live",
      link: "https://github.com/kennythai2003/nommies",
      image: nommiesIcon,
    },
    {
      id: 3,
      name: "PlanIt",
      description:
        "Task and event planning application with calendar integration and reminders.",
      technologies: ["C++", "OOP", "Git", "CI/CD", "Unit Testing", "SCRUM"],
      status: "Completed",
      link: "https://github.com/kennythai2003/planit",
      image: planitIcon,
    },
    {
      id: 4,
      name: "Breast Cancer Classifier",
      description:
        "Machine learning model that uses both supervised and unsupervised learning to classify breast cancer tumors as malignant or benign.",
      technologies: ["Python", "Scikit-learn", "Pandas", "NumPy", "matplotlib"],
      status: "Live",
      link: "https://github.com/kennythai2003/breastcanceranalysis",
      image: breastIcon,
    },
    {
      id: 5,
      name: "Chicago Crimes Analysis",
      description:
        "Data analysis and visualization of Chicago crime statistics and trends.",
      technologies: ["Beast", "Hadoop", "Scala", "GIS"],
      status: "Completed",
      link: "https://github.com/kennythai2003/chicago-crimes",
      image: chicagoIcon,
    },
    {
      id: 6,
      name: "Bop It (At Home)",
      description:
        "Interactive recreation of the classic Bop It game using hardware and sensors",
      technologies: ["Arduino", "C++", "SSM"],
      status: "Live",
      link: "https://github.com/kennythai2003/bop-it",
      image: bopitIcon,
    },
  ];

  return (
    <div className="projects-app">
      <div className="projects-header">
        <h1 className="projects-title">My Projects</h1>
        <p className="projects-subtitle">Check out what I've been building!</p>
      </div>

      <div className="bulletin-board">
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div
              key={project.id}
              className={`project-card rotation-${index % 3}`}
            >
              <div className="thumbtack"></div>
              <div className="polaroid">
                <div className="polaroid-image">
                  <img
                    src={project.image}
                    alt={project.name}
                    className="project-image"
                  />
                </div>
                <div className="polaroid-content">
                  <h3 className="project-title">{project.name}</h3>
                  <p className="project-description">{project.description}</p>
                  <div className="tech-tags">
                    {project.technologies.map((tech, idx) => (
                      <span key={idx} className="tech-tag">
                        {tech}
                      </span>
                    ))}
                  </div>
                  <a
                    href={project.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="view-project-btn"
                  >
                    View on GitHub →
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectsApp;
